
export default class EditorSettings {
    constructor() {
        this.uniqueAttrNames = ko.observable();
        this.snapOnlyToUniqueAttrs = ko.observable(false);
        this.dontUseHrefs = ko.observable(true);
        this.dontDetectDynamicUrlParts = ko.observable(false);
        this.ignoreClassList = ko.observable();

        this.uniqueAttrNames.subscribe((val) => {
            if (!val) this.snapOnlyToUniqueAttrs(false);
        });

        this.loadFromLocalStorage();
    }

    loadFromLocalStorage() {
        let saved = localStorage.getItem('pf_editor_settings_v2');
        if (!saved) return;

        saved = JSON.parse(saved);

        this.uniqueAttrNames(saved.uniqueAttrNames);
        this.snapOnlyToUniqueAttrs(saved.snapOnlyToUniqueAttrs);
        this.dontUseHrefs(saved.dontUseHrefs);
        this.dontDetectDynamicUrlParts(saved.dontDetectDynamicUrlParts);
        this.ignoreClassList(saved.ignoreClassList);
    }

    saveToLocalStorage() {
        localStorage.setItem('pf_editor_settings_v2', JSON.stringify(ko.toJS(this)));
    }

    toJS() {
        return ko.toJS(this);
    }
}